'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var components_form_FormContext = require('./FormContext.js');
var InternalStack = require('../../_chunks/InternalStack-CFsUMwV1.js');
var translation = require('@templafy/translation');
var hooks_useUUID = require('../../hooks/useUUID.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var HelpMessage = require('../../_chunks/HelpMessage-9IXnyzAp.js');
var FieldContext = require('../../_chunks/FieldContext-DI94tJqT.js');
var transitions_collapsible_Collapsible = require('../../transitions/collapsible/Collapsible.js');
var hooks_useCombinedRefs = require('../../hooks/useCombinedRefs.js');
var components_visuallyHidden_VisuallyHidden = require('../visuallyHidden/VisuallyHidden.js');
var components_button_Button = require('../button/Button.js');
var icons_IconChevron = require('../../icons/IconChevron.js');
var icons_IconDanger = require('../../icons/IconDanger.js');
var components_cluster_Cluster = require('../cluster/Cluster.js');
var hooks_useCallbackRef = require('../../hooks/useCallbackRef.js');
var useDevelopmentEffect = require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
var components_stack_Stack = require('../stack/Stack.js');
var Label = require('../../_chunks/Label-yBaxnb0E.js');
var utilities_createComponentNamespace = require('../../utilities/createComponentNamespace.js');
require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');
require('../../icons/IconSuccess.js');
require('../../icons/Icon.js');
require('../../icons/IconAlert.js');
require('../text/Text.js');
require('../../_chunks/fonts-CZ0t0x6L.js');
require('lodash/isNumber');
require('react-transition-group');
require('../../utilities/string.js');
require('../../_chunks/BaseButton-DDcpn9-P.js');
require('../../icons/IconLoading.js');
require('../../_chunks/InternalCluster-CI9J3-Do.js');
require('../tooltipIndicator/TooltipIndicator.js');
require('../../icons/IconInfo.js');
require('../tooltip/Tooltip.js');
require('../../hooks/useFocus.js');
require('../../hooks/useHover.js');
require('../../_chunks/useOnEscape-vb8gPtDo.js');
require('../../_chunks/useEventListener-DSwo06ND.js');
require('../floatingContainer/FloatingContainer.js');
require('@floating-ui/react-dom');
require('../../transitions/fade/Fade.js');
require('../portal/Portal.js');
require('react-dom');
require('../../theme/ThemeProvider.js');

require("../../_assets/Form-DxhZEDVY.css");var styles$2 = {"autoLayout":"Form__0dgf5icG4D__autoLayout","form":"Form__0dgf5icG4D__form"};

require("../../_assets/FieldSet-D2sQjF09.css");var styles$1 = {"defaultSpacing":"FieldSet__WH7DfyKoqM__defaultSpacing","fieldSet":"FieldSet__WH7DfyKoqM__fieldSet","fieldsetContent":"FieldSet__WH7DfyKoqM__fieldsetContent","fieldSetLabelTypography":"FieldSet__WH7DfyKoqM__fieldSetLabelTypography","label":"FieldSet__WH7DfyKoqM__label"};

require("../../_assets/FieldSetToggleButton-ekMTJVEO.css");var styles = {"contentWrapper":"FieldSetToggleButton__uQKHNuSjx-__contentWrapper","icon":"FieldSetToggleButton__uQKHNuSjx-__icon","label":"FieldSetToggleButton__uQKHNuSjx-__label","toggleButton":"FieldSetToggleButton__uQKHNuSjx-__toggleButton"};

const FieldSetToggleButton = react.forwardRef(({ expanded, showDangerIcon, className, children, ...props }, ref) => {
    return (jsxRuntime.jsx(components_button_Button.Button, { variant: "ghost", className: utilities_combineClasses.combineClasses(styles.toggleButton, styles$1.fieldSetLabelTypography, className), ...props, ref: ref, children: (jsxRuntime.jsxs(components_cluster_Cluster.Cluster, { gap: "100", children: [jsxRuntime.jsx(icons_IconChevron.IconChevron, { className: styles.icon, rotation: expanded ? undefined : 270, color: "gray-800" }), jsxRuntime.jsx("div", { className: styles.label, children: children }), showDangerIcon && (jsxRuntime.jsx(icons_IconDanger.IconDanger, { className: styles.icon, color: "danger-600" }))] })) }));
});
FieldSetToggleButton.displayName = 'FieldSetToggleButton';

const FieldSet = react.forwardRef(({ testId, className, style, title, description, disabled, readOnly, required, size, status, children, open, onOpenChange, gap = 'auto', collapsible, ...props }, ref) => {
    const fieldsetRef = react.useRef(null);
    const combinedRef = hooks_useCombinedRefs.useCombinedRefs(ref, fieldsetRef);
    const submitCounter = components_form_FormContext.useFormContext()?.submitCounter;
    const fieldsetId = hooks_useUUID.useUUID({ prefix: 'fieldset' });
    const descriptionId = hooks_useUUID.useUUID({ prefix: 'fieldset-description' });
    const [hasInvalidFields, setHasInvalidFields] = react.useState(false);
    const translator = translation.useTranslator();
    const isOpenControlled = onOpenChange !== undefined || open !== undefined;
    const [isInternalOpen, setIsInternalOpen] = react.useState(true);
    const isOpen = isOpenControlled ? open : isInternalOpen;
    const onOpenChangeRef = hooks_useCallbackRef.useCallbackRef((nextOpen) => {
        if (isOpenControlled) {
            onOpenChange?.(nextOpen);
        }
        else {
            setIsInternalOpen(nextOpen);
        }
    });
    useDevelopmentEffect.useDevelopmentEffect(() => {
        if (isOpenControlled && collapsible !== undefined) {
            console.error('[Form.FieldSet]: The `collapsible` prop should not be set when `open` or `onOpenChange` are provided. Ignoring the `collapsible` prop.');
        }
    });
    const isCollapsible = collapsible ?? Boolean(onOpenChange);
    const value = react.useMemo(() => ({
        disabled,
        readOnly,
        required,
        size,
        status,
        onInputStatusChange: () => {
            const invalidInputs = fieldsetRef.current?.querySelectorAll('[aria-invalid="true"]') ??
                [];
            if (invalidInputs.length > 0) {
                setHasInvalidFields(true);
                onOpenChangeRef.current(true);
            }
            else {
                setHasInvalidFields(false);
            }
        },
    }), [disabled, readOnly, required, size, status, onOpenChangeRef]);
    react.useEffect(() => {
        // re-opening all invalid fields after submission
        if (hasInvalidFields) {
            onOpenChangeRef.current(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitCounter]);
    return (jsxRuntime.jsx(FieldContext.FieldsetContext.Provider, { value: value, children: jsxRuntime.jsxs("fieldset", { className: utilities_combineClasses.combineClasses(className, styles$1.fieldSet), style: style, "data-testid": testId, "aria-describedby": descriptionId, disabled: disabled, id: fieldsetId, "data-collapsed": !isOpen, ref: combinedRef, children: [isCollapsible ? (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("legend", { children: jsxRuntime.jsx(components_visuallyHidden_VisuallyHidden.VisuallyHidden
                            // the legend cannot be used directly as button text for the toggle, so is only used for accessibility but visually hidden
                            , { children: title }) }), jsxRuntime.jsx(FieldSetToggleButton, { "aria-controls": fieldsetId, "aria-expanded": isOpen, "aria-label": translator.uiComponentsFieldSetToggleButtonPrefix({
                                title,
                            }), onClick: () => onOpenChangeRef.current(!isOpen), showDangerIcon: hasInvalidFields, expanded: isOpen, testId: "toggle-button", children: jsxRuntime.jsx("span", { "aria-hidden": true, "data-testid": "title", children: title }) })] })) : (jsxRuntime.jsx("legend", { "data-testid": "title", className: utilities_combineClasses.combineClasses(styles$1.label, styles$1.fieldSetLabelTypography), children: title })), jsxRuntime.jsxs(transitions_collapsible_Collapsible.Collapsible, { visible: isOpen, children: [description && (jsxRuntime.jsx(HelpMessage.HelpMessage, { id: descriptionId, testId: "description", children: description })), jsxRuntime.jsx(InternalStack.InternalStack, { className: utilities_combineClasses.combineClasses(styles$1.fieldsetContent, gap === 'auto' && styles$1.defaultSpacing), gap: gap === 'auto' ? undefined : gap, ...props, children: children })] })] }) }));
});
FieldSet.displayName = 'FieldSet';

const Field = react.forwardRef(({ children, ...stackProps }, ref) => {
    const fieldSetContext = FieldContext.useFieldsetContext();
    const inputId = hooks_useUUID.useUUID({ prefix: 'input' });
    const labelId = hooks_useUUID.useUUID({ prefix: 'label' });
    const [descriptionIds, setDescriptionIds] = react.useState([]);
    const [errorMessageIds, setErrorMessageIds] = react.useState([]);
    const [inputType, setInputType] = react.useState();
    const [status, setStatus] = react.useState();
    const [size, setSize] = react.useState();
    const [disabled, setDisabled] = react.useState();
    const [readOnly, setReadOnly] = react.useState();
    const [required, setRequired] = react.useState();
    const addDescriptionId = react.useCallback((id) => setDescriptionIds((ids) => [...ids, id]), []);
    const removeDescriptionId = react.useCallback((id) => setDescriptionIds((ids) => ids.filter((index) => index !== id)), []);
    const addErrorMessageId = react.useCallback((id) => setErrorMessageIds((ids) => [...ids, id]), []);
    const removeErrorMessageId = react.useCallback((id) => setErrorMessageIds((ids) => ids.filter((index) => index !== id)), []);
    react.useEffect(() => {
        fieldSetContext?.onInputStatusChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);
    const contextValue = react.useMemo(() => ({
        inputId,
        labelId,
        inputType,
        setInputType,
        status,
        setStatus,
        size,
        setSize,
        disabled,
        setDisabled,
        readOnly,
        setReadOnly,
        required,
        setRequired,
        descriptionIds,
        addDescriptionId,
        removeDescriptionId,
        errorMessageIds,
        addErrorMessageId,
        removeErrorMessageId,
    }), [
        inputId,
        labelId,
        inputType,
        status,
        size,
        disabled,
        readOnly,
        required,
        descriptionIds,
        addDescriptionId,
        removeDescriptionId,
        errorMessageIds,
        addErrorMessageId,
        removeErrorMessageId,
    ]);
    return (jsxRuntime.jsx(FieldContext.FieldContextProvider, { value: contextValue, children: jsxRuntime.jsx(components_stack_Stack.Stack, { gap: "100", "data-input-type": inputType, ref: ref, ...stackProps, children: children }) }));
});
Field.displayName = 'Field';

const ValidationMessage = react.forwardRef(({ status: statusProperty, ...props }, ref) => {
    const fieldContext = FieldContext.useFieldContext();
    const status = statusProperty ?? fieldContext?.status;
    return (jsxRuntime.jsx(HelpMessage.BaseMessage, { status: status, testId: "validation-message", ...props, ref: ref }));
});
ValidationMessage.displayName = 'ValidationMessage';

// eslint-disable-next-line react/display-name
const FormComponent = react.forwardRef(({ disabled, readOnly, required, size, status, onSubmit, className, gap = 'auto', ...props }, ref) => {
    const [submitCounter, setSubmitCounter] = react.useState(0);
    const formRef = react.useRef(null);
    const contextValue = react.useMemo(() => ({
        disabled,
        readOnly,
        required,
        size,
        status,
        submitCounter,
    }), [disabled, readOnly, required, size, status, submitCounter]);
    react.useEffect(() => {
        const firstInvalidElement = formRef.current?.querySelectorAll('[aria-invalid="true"]')[0];
        if (!firstInvalidElement) {
            return;
        }
        const focusInvalidElement = () => {
            firstInvalidElement.focus();
            // some invalid elements might not be focusable (e.g radiogroup). We highlight those to the user by scrolling to them.
            firstInvalidElement.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        };
        const fieldsetAncestor = firstInvalidElement.closest('fieldset');
        // the invalid element might be hidden in a collapsed fieldset.
        // in that case, we wait for the fieldset to expand before focusing the element.
        if (fieldsetAncestor && fieldsetAncestor.dataset.collapsed === 'true') {
            const observer = new MutationObserver(() => {
                if (fieldsetAncestor.dataset.collapsed === 'false') {
                    observer.disconnect();
                    focusInvalidElement();
                }
            });
            observer.observe(fieldsetAncestor, {
                attributes: true,
                attributeFilter: ['data-collapsed'],
            });
            return () => {
                observer.disconnect();
            };
        }
        focusInvalidElement();
    }, [submitCounter]);
    return (jsxRuntime.jsx(components_form_FormContext.FormContextProvider, { value: contextValue, children: jsxRuntime.jsx(InternalStack.InternalStack, { as: "form", noValidate // to avoid the default html tooltips on required fields
            : true, gap: gap === 'auto' ? '0' : gap, className: utilities_combineClasses.combineClasses(className, styles$2.form, gap === 'auto' && styles$2.autoLayout), ref: hooks_useCombinedRefs.useCombinedRefs(formRef, ref), onSubmit: (event) => {
                event.preventDefault();
                void Promise.resolve(onSubmit(event)).finally(() => {
                    // making sure that the submit counter is only increased once the onSubmit is executed
                    // so the validation is already done
                    setSubmitCounter((counter) => counter + 1);
                });
            }, ...props }) }));
});
const Form = utilities_createComponentNamespace.createComponentNamespace({
    component: FormComponent,
    componentList: {
        FieldSet,
        Field,
        Label: Label.Label,
        HelpMessage: HelpMessage.HelpMessage,
        ValidationMessage,
    },
    namespace: 'Form',
});
Form.displayName = 'Form';

exports.Form = Form;
//# sourceMappingURL=Form.js.map
